import axios from 'axios';

export const kyc3Axios = axios.create({
  baseURL: process.env.REACT_APP_KYC3_URL,
  timeout: 60 * 1000,
  headers: { accept: 'application/json' },
});
